import { useMutation } from '@tanstack/react-query';
import { VehicleApi } from 'api';

export function useShareVehicles() {
  return useMutation({
    mutationKey: ['share-vehicles'],
    mutationFn: (data) => VehicleApi.shareVehicles(data),
  });
}
